<mat-form-field
  appearance="outline"
  [ngClass]="ssnMatFieldClass"
  [class.ssn-field-error]="control.invalid && (control.touched || control.dirty)">
  @if (showFullSsn) {
    @if (allowFullSsnEdit) {
      <input [id]="id" matInput type="text" [formControl]="control" [ssnMask]="false"
             [maxlength]="11" inputmode="numeric" autocomplete="off" [attr.aria-describedby]="ariaErrorId"
             (blur)="onUnmaskedBlurForFullEdit()"
             [placeholder]="placeholder" [ngClass]="ssnFieldClass"/>
    } @else {
      <input [id]="id" matInput type="text" readonly [value]="revealSsnDisplay" [placeholder]="placeholder" [ngClass]="ssnFieldClass"/>
    }
  } @else {
    <input #maskedInput [id]="id" matInput type="text" [formControl]="control" [ssnMask]="useMaskedEditMode"
           [ssnMaskLockCaretToEnd]="!allowFullSsnEdit"
           [maxlength]="11" inputmode="numeric" autocomplete="off" [attr.aria-describedby]="ariaErrorId"
           [readonly]="allowFullSsnEdit"
           (focus)="onMaskedFocusForFullEdit()"
          (click)="onMaskedFocusForFullEdit()"
           [placeholder]="placeholder" [ngClass]="ssnFieldClass"/>
  }

  @if (editable && useMaskedEditMode) {
    <button mat-icon-button matSuffix type="button" class="{{ eyeButtonClass }}"
            [disableRipple]="true"
            (click)="toggleVisibility()"
            [disabled]="control.errors?.['required'] || control.errors?.['invalidSSN'] || (allowFullSsnEdit && lockEyeToggleDuringFullEdit)"
            [attr.aria-label]="showFullSsn ? 'Hide full SSN' : 'Show full SSN'">
      <mat-icon>{{ showFullSsn ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
  }
</mat-form-field>